function injectStyle (ssrContext) {
  require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-9aa87568\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"indentedSyntax\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Docs.vue")
}
var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Docs.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-9aa87568\",\"hasScoped\":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Docs.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9aa87568",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modules/deals/views/components/Docs.vue
// module id = 933
// module chunks = 0